import React from 'react';
import { useRequestFormsForManagerQuery } from '../../../__generated__/graphql';
import Loading from '../../Loading';
import { RequestForm } from '../RequestForm';
import { RequestFormProps } from '../RequestForm/types';

export const ManagerRequestForm: React.FC<RequestFormProps> = (props) => {
  const { data, loading } = useRequestFormsForManagerQuery();

  if (loading || !data) {
    return <Loading />;
  }

  return (
    <RequestForm
      {...props}
      requestForms={data.requestForms}
      employees={data.manager.employees}
    />
  );
};
